import { render, staticRenderFns } from "./BannerAd.vue?vue&type=template&id=f9db4304&scoped=true&"
import script from "./BannerAd.vue?vue&type=script&lang=js&"
export * from "./BannerAd.vue?vue&type=script&lang=js&"
import style0 from "./BannerAd.vue?vue&type=style&index=0&id=f9db4304&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9db4304",
  null
  
)

export default component.exports